const STORAGE_KEY = "admin:token";

/**
 * Токен админки живёт часами, а не днями, и refresh-токена у него нет: при 401
 * администратор логинится заново. Молчаливого релогина, как в мини-аппе, здесь
 * быть не может — там `initData` приходит от Telegram, а тут нужен пароль и
 * код второго фактора.
 *
 * `sessionStorage`, а не `localStorage`: закрытая вкладка админки должна
 * означать закрытую сессию. Это не паранойя — админка меняет чужие балансы, и
 * она открывается с рабочих машин, где вкладку закрывают, а браузер нет.
 */
let cached: string | null = null;

export function getToken(): string | null {
  if (cached !== null) return cached;
  try {
    cached = sessionStorage.getItem(STORAGE_KEY);
  } catch {
    // Storage может быть запрещён политикой браузера. Тогда токен живёт
    // только в памяти — до перезагрузки страницы.
    cached = null;
  }
  return cached;
}

export function setToken(token: string): void {
  cached = token;
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* см. выше */
  }
}

export function clearToken(): void {
  cached = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* см. выше */
  }
}
